import React, { Fragment, useState } from 'react';
import { message } from 'antd';
import { isEmptyObject } from '../../../helpers/helpers';
import TabSelector from '../../Shared/Filters/TabSelector';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';
import { Manage } from 'config/commonTypes';

type EventLoggerProps = {
  editable: boolean;
  currentPractice: Manage;
  setEditable: React.Dispatch<React.SetStateAction<boolean>>;
  handleEditSwith: () => void,
  handleCustomEventSave: () => void
  
}
const EventLoggerHeader =  ({editable, currentPractice, setEditable, handleEditSwith, handleCustomEventSave}: EventLoggerProps) => {
  
  const { practiceSaved } = useFlagsState();
  const { changePracticeSavedSuccessfullyFlag } = useFlagsDispatch();
  const hidePracticeSavedMessage = () => {
    changePracticeSavedSuccessfullyFlag(false);
  };

  const [show, setShow] = useState(-1);
  
  const handleEditingChange = () => {
    setEditable(!editable);
    handleEditSwith();

  };

  if (practiceSaved) {
    // show message and then clear flags
    message.success({
      content: 'Practice Successfully Saved',
      className: 'message-pro',
      style: {
        marginTop: '60vh'
      }
    }, 10);
    hidePracticeSavedMessage();
  }
 

  return (

    <Fragment>
      <TabSelector show={show === 1} open={() => setShow(1)} close={() => setShow(-1)} />
      <div className="manage-btn">
        <div className={'switch-00' + (isEmptyObject(currentPractice) ? ' box-disabled' : '')}>
          <label className="label-009" onClick={()=>{handleEditingChange();}}>{'Editing ' + (editable ? 'Unlocked' : 'Locked')}</label>
          <input
            type="checkbox" id="editing-practice-manager" name="set-name" className="switch-input"
            checked={editable}
            onChange={() => handleEditingChange()}
          />
          <label htmlFor="editing-practice-manager" id="editing-practice-manager-label" className="switch-label" />
        </div>
        <button
          className={'btn-green'} onClick={() => {
            setEditable(false);
            handleCustomEventSave();}}
          style={editable ? {} : {opacity: 0.5, cursor: 'default', pointerEvents: 'none'}}
        >
          Save
        </button>
      </div>
    </Fragment>
  );
};
export default EventLoggerHeader;
